import '../shared/bootDiagnostics';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import AdminApp from './AdminApp';
import { antdLocale } from '../shared/locale';
import ErrorBoundary from '../shared/components/ErrorBoundary';
import { ADMIN_BASE_PATH } from '../shared/config/paths';
import '../index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <BrowserRouter basename={ADMIN_BASE_PATH || '/'}>
                {/* 仅设置语言（admin 未接 ThemeProvider，这里不改主题） */}
                <ConfigProvider locale={antdLocale}>
                    <AdminApp />
                </ConfigProvider>
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>
);
